"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getControlledTableProps = getControlledTableProps;
exports.default = useControllableTableConsumer;

var _react = require("react");

var _reactTable = require("react-table");

// This hook consumes the data provided by useControllableTable
function getControlledTableProps(enabled) {
  return {
    manualSorting: enabled,
    manualFilters: enabled,
    manualPagination: enabled,
    disableMultiSort: enabled,
    disableGrouping: enabled,
    autoResetPage: !enabled,
    autoResetExpanded: !enabled,
    autoResetGroupBy: !enabled,
    autoResetSelectedRows: !enabled,
    autoResetSortBy: !enabled,
    autoResetFilters: !enabled,
    autoResetRowState: !enabled
  };
}

function useControllableTableConsumer(enabled, onControlsChange, tableInstance) {
  var onControlsChangeDebounced = (0, _reactTable.useAsyncDebounce)(onControlsChange, 100);
  (0, _react.useEffect)(function () {
    if (enabled) {
      onControlsChangeDebounced({
        sortBy: tableInstance.state.sortBy,
        filters: tableInstance.state.filters,
        pageIndex: tableInstance.state.pageIndex,
        pageSize: tableInstance.state.pageSize,
        pageCount: tableInstance.pageCount
      });
    }
  }, [tableInstance.state.sortBy, tableInstance.state.filters, tableInstance.state.pageIndex, tableInstance.state.pageSize, tableInstance.pageCount, onControlsChangeDebounced, enabled]);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/containers/data_table/useControllableTableConsumer.js
// module id = 777
// module chunks = 0 15 16 17 18